import { splitId } from './splitIdsFromBackEnd';

export const findAndMatchTargetGroup = (
  currentRoadmapId: string,
  currentRoadmapName: string,
  filterRoadmapId: string,
) => {
  if (currentRoadmapId === filterRoadmapId) {
    return { id: currentRoadmapId, name: currentRoadmapName, matchOrNotApply: true };
  } else {
    return {
      id: currentRoadmapId,
      name: currentRoadmapName,
      matchOrNotApply: currentRoadmapId !== splitId(filterRoadmapId) ? false : true,
    };
  }
};

export const getTargetGroupById = (currentRoadmapId: string, currentRoadmapName: string, filterRoadmapId: string) => {
  if (currentRoadmapId === '-1' || currentRoadmapId === null) {
    return { id: null, name: null, matchOrNotApply: true };
  }

  return findAndMatchTargetGroup(currentRoadmapId, currentRoadmapName, filterRoadmapId);
};
